<template>
    <div class="item pr-4 pl-10 sm:pr-6 border-b border-gray-300">
        <div class="flex justify-between items-center py-4">
            <div class="flex">
                <div class="relative">
                    <i class="handle absolute fa fa-bars text-gray-300 cursor-move p-2" style="left: -32px;"></i>
                    <slot></slot>
                </div>
            </div>
            <div class="flex items-center text-sm">
                <slot name="edit-component"></slot>
                <a class="link link-danger" href="#" @click.stop.prevent="$emit('delete', itemKey)">
                    <i class="fa fa-trash-o"></i>
                    <span class="hidden sm:inline-block">Remove</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        itemKey: {
            type: Number,
            required: true
        }
    }
};
</script>
